import { render } from "./FooterContainer.vue?vue&type=template&id=4c883a4a&scoped=true"
import script from "./FooterContainer.vue?vue&type=script&lang=js"
export * from "./FooterContainer.vue?vue&type=script&lang=js"

import "./FooterContainer.vue?vue&type=style&index=0&id=4c883a4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c883a4a"]])

export default __exports__